import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackShippingInfoChangedParameters extends TrackEventBaseParameters {}

const trackShippingInfoChanged = (
    parameters: TrackShippingInfoChangedParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "shipping_info_changed", ...parameters }, options);
};

export default trackShippingInfoChanged;
